import CookieManager from './utils/cookie-manager';

export default function initBandeauNews() {
    if (document.querySelector('.main .bandeau_news')) {
        new BandeauNews(document.querySelector('.main .bandeau_news'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class BandeauNews {
    constructor($el) {
        this.$el = $el;
        this.$btnClose = this.$el.querySelector('.js-btn-close-bandeau');
        this.$headerIntro = document.querySelector('header.intro');
        this.init();
    }

    init() {
        this.$btnClose.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.$el.classList.add('hidden');
            this.$headerIntro.classList.remove('with_bandeau_news');
            CookieManager.setCookie('bandeau_news', 'closed', false);
        });
    }
}
